import ICON_CUSTOMS from '@/assets/korUploadFile/icon_customs.png';
import ICON_CAUTION from '@/assets/korUploadFile/icon_caution.png';
import { Button } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  onClick: () => void;
};

const SubstituteGuideModal = ({ onClick }: Props) => {
  return (
    <Backdrop>
      <Wrapper>
        <Title>
          <img src={ICON_CAUTION} alt='' width={24} />
          출입국 사실증명서 대체 자료 안내
        </Title>
        <Explain>
          한국 주민등록번호 및 휴대폰 번호가 없는 경우
          <br />
          하단의 자료로 출국 확인이 진행됩니다.
          <br />
          항공권과 해외체류증빙자료를 촬영하여 업로드 해주세요.
        </Explain>
        <ContentsWrapper>
          <ContentsTitle>
            <img src={ICON_CUSTOMS} alt='' width={24} />
            <strong>업로드 필요서류</strong>
          </ContentsTitle>
          <span>
            <ContentsSubtitle>
              <strong>1. 출입국 항공권 (E-Ticket 가능)</strong>
            </ContentsSubtitle>
            <ContentsExplain>
              이름, 날짜, 입국공항명(해외 → 한국) 및 출국공항명(한국 → 해외)이
              포함된 항공권 이미지
            </ContentsExplain>
          </span>
          <span>
            <ContentsSubtitle>
              <strong>2. 해외체류증빙자료</strong>
            </ContentsSubtitle>
            <ContentsExplain>
              영주권, 거주자카드(재류카드), 비자, 해외거주 사실확인서 중 1가지
            </ContentsExplain>
          </span>
        </ContentsWrapper>
        <SmallText>
          출입국 항공권과 해외체류증빙자료 2가지 모두 업로드 해주세요.
        </SmallText>
        <Button type='button' onClick={onClick}>
          확인
        </Button>
      </Wrapper>
    </Backdrop>
  );
};
export default SubstituteGuideModal;

const Backdrop = styled.div`
  position: fixed;
  inset: 0 0 0 0;
  background-color: #03030340;
  z-index: 999;
`;

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #fff;
  padding: 24px 20px;
  border-radius: 12px 12px 0 0;
`;

const Title = styled.h6`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--KTP-Grayscale-100, var(--KTP-Color-Mono-100, #030303));
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.4px;
`;

const Explain = styled.p`
  color: var(--KTP-Grayscale-Gray_05, #777);
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const ContentsWrapper = styled.p`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px;
  background-color: #fafafa;
`;

const ContentsTitle = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  color: var(--KTP-Grayscale-Gray_02, #111);
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const ContentsSubtitle = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  color: var(--KTP-Grayscale-Gray_02, #111);
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const ContentsExplain = styled.span`
  color: var(--KTP-Grayscale-Gray_05, #777);
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.26px;
  word-break: keep-all;
`;

const SmallText = styled.small`
  color: var(--KTP-Grayscale-Gray_03, #333);
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%; /* 16.8px */
  letter-spacing: -0.24px;
`;
